// extracted by mini-css-extract-plugin
export default {"board":"Board_board__hbx+7","board-col":"Board_board-col__Rpfrr","board-col-active":"Board_board-col-active__S3XlB"};